var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"calc(100vh - 50px)"}},[_c('RelationGraph',{ref:"seeksRelationGraph",attrs:{"options":_vm.graphOptions,"on-node-click":_vm.onNodeClick,"on-line-click":_vm.onLineClick}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }